import { AppTenant, TenantId } from '../types';

export const isValidTenantId = (
  tenantId: string | TenantId,
): tenantId is TenantId =>
  Object.values(AppTenant).includes(tenantId as AppTenant);
